<template>
  <div class="hero-illustration">
    <!-- inline SVG! -->
    <div class="illustrations">

      <parallax-container>

        <parallax-element class="background-image" :parallaxStrength="-30" :type="'translation'">
          <analytics />
        </parallax-element>

        <parallax-element class="background-image" :parallaxStrength="-40" :type="'translation'">
          <iphone />
        </parallax-element>

        <parallax-element class="background-image" :parallaxStrength="-20" :type="'translation'">
          <pillar-left/>
        </parallax-element>

        <parallax-element class="background-image" :parallaxStrength="-20" :type="'translation'">
          <character-left/>
        </parallax-element>

        <parallax-element class="background-image" :parallaxStrength="-10" :type="'translation'">
          <chat-boxes-light/>
        </parallax-element>

        <parallax-element class="background-image" :parallaxStrength="-20" :type="'translation'">
          <pillar-mid/>
        </parallax-element>

        <parallax-element class="background-image" :parallaxStrength="-20" :type="'translation'">
          <character-mid/>
        </parallax-element>

        <parallax-element class="background-image" :parallaxStrength="-10" :type="'translation'">
          <send-money/>
        </parallax-element>

        <parallax-element class="background-image" :parallaxStrength="-20" :type="'translation'">
          <pillar-right/>
        </parallax-element>

        <parallax-element class="background-image" :parallaxStrength="-20" :type="'translation'">
          <character-right/>
        </parallax-element>

        <parallax-element class="background-image" :parallaxStrength="-10" :type="'translation'">
          <chat-boxes-dark/>
        </parallax-element>

        <parallax-element class="background-image" :parallaxStrength="-14" :type="'translation'">
          <pillar-bottom/>
        </parallax-element>

        <parallax-element class="background-image" :parallaxStrength="-14" :type="'translation'">
          <character-bottom/>
        </parallax-element>

      </parallax-container>
    </div>
  </div>
</template>

<style lang="scss">
.hero-illustration {
  // background: rgba(0, 255, 100, 0.3);
  position: relative;
  padding-top: 90%; // Setting relative size
  .illustrations, .parallax-container, .parallax-element {
    position: absolute;
    height: 100%;
    width: 100%;
    top: 0;
    left: 0;
    svg {
      position: absolute;
    }
  }

  @keyframes fade-up {
  0%   {
    opacity: 0;
    transform: translateY(10px);

  }
  100% {
    opacity: 1;
    transform: translateY(0px);
    }
  }

  $illustration-height: 898.92;
  $illustration-width: 1000;

  @mixin setPosition($left, $top, $width, $height) {
    position: absolute;
    left: $left / $illustration-width * 100%;
    top: $top / $illustration-height * 100%;
    width: $width / $illustration-width * 100%;
    height: $height / $illustration-height * 100%;
  }

  @mixin revealFade($animation-delay) {
    animation: fade-up $animation-delay ease;
  }

  // pillars

  .pillar-left {
    @include setPosition(102.126, 373.985, 223.161, 471.523);
    filter: drop-shadow( 0px 5px 13px rgba(0, 0, 0, .2));
    @include revealFade(2.3s)
  }
  .pillar-mid {
    @include setPosition(357.346, 260.874, 223.161, 471.523);
    filter: drop-shadow( 0px 5px 13px rgba(0, 0, 0, .4));
    @include revealFade(2.8s)
  }
  .pillar-right {
    @include setPosition(639.788, 313.015, 223.161, 471.523);
    filter: drop-shadow( 0px 5px 13px rgba(0, 0, 0, .2));
    @include revealFade(2.3s)
  }
  .pillar-bottom {
    @include setPosition(308.325, 436.682, 422.27, 462.236);
    filter: drop-shadow( 0px 5px 13px rgba(0, 0, 0, .4));
    @include revealFade(1s)
  }

  // characters

  .character-left {
    @include setPosition(145.997, 116.016, 129.307, 334.457);
    @include revealFade(3s)
  }
  .character-mid {
    @include setPosition(440.764, 30.487, 98.035, 323.156);
    @include revealFade(1s)
  }
  .character-right {
    @include setPosition(680.368, 216.901, 135.735, 183.13);
    @include revealFade(3s)
  }
  .character-bottom {
    @include setPosition(313.058, 467.364, 155.016, 287.598);
    @include revealFade(1.5s)
  }

  // details
  .analytics {
    @include setPosition(0, 0, 369.329, 388.324);
    filter: drop-shadow( 5px 8px 13px rgba(0, 0, 0, .2));
    @include revealFade(3s)
  }
  .chat-boxes-light {
    @include setPosition(344.893, 22.308, 90.198, 158.268);
    filter: drop-shadow( 0px 8px 13px rgba(0, 0, 0, .2));
    @include revealFade(3s)
  }
  .chat-boxes-dark {
    @include setPosition(552.92, 206.776, 116.027, 162.653);
    filter: drop-shadow( 0px 8px 13px rgba(0, 0, 0, .2));
    @include revealFade(3s)
  }
  .send-money {
    @include setPosition(535.764, 46.129, 295.782, 217.573);
    filter: drop-shadow( 0px 8px 13px rgba(0, 0, 0, .2));
    @include revealFade(3s)
  }
  .iphone {
    @include setPosition(821.829, 161.993, 176.565, 410.343);
    filter: drop-shadow( 8px 13px 21px rgba(0, 0, 0, .25));
    @include revealFade(3s)
  }
}
</style>

<script>
import pillarLeft from './heroIllustration/pillarLeft.vue'
import pillarMid from './heroIllustration/pillarMid.vue'
import pillarRight from './heroIllustration/pillarRight.vue'
import pillarBottom from './heroIllustration/pillarBottom.vue'
import characterLeft from './heroIllustration/characterLeft.vue'
import characterMid from './heroIllustration/characterMid.vue'
import characterRight from './heroIllustration/characterRight.vue'
import characterBottom from './heroIllustration/characterBottom.vue'
import analytics from './heroIllustration/analytics.vue'
import chatBoxesLight from './heroIllustration/chatBoxesLight.vue'
import chatBoxesDark from './heroIllustration/chatBoxesDark.vue'
import sendMoney from './heroIllustration/sendMoney.vue'
import iphone from './heroIllustration/iphone.vue'

export default {
  name: 'heroIllustration',
  components: {
    pillarLeft,
    pillarMid,
    pillarRight,
    pillarBottom,
    characterLeft,
    characterMid,
    characterRight,
    characterBottom,
    analytics,
    chatBoxesLight,
    chatBoxesDark,
    sendMoney,
    iphone
  }
}
</script>
